const INDEX_ITEMS = [
  { label: '动作电影', count: '2,368部', icon: 'ri-sword-line' },
  { label: '喜剧电影', count: '1,892部', icon: 'ri-emotion-laugh-line' },
  { label: '爱情电影', count: '1,456部', icon: 'ri-heart-line' },
  { label: '科幻电影', count: '1,203部', icon: 'ri-rocket-line' },
  { label: '恐怖惊悚', count: '987部', icon: 'ri-ghost-line' },
  { label: '动画电影', count: '1,645部', icon: 'ri-movie-line' },
  { label: '纪录影片', count: '876部', icon: 'ri-camera-line' },
  { label: '战争电影', count: '634部', icon: 'ri-shield-line' },
];

const UPDATES = [
  { date: '07-31', title: '暑期重磅：《封神第二部》高清完整版正式上线', tag: '最新上线' },
  { date: '07-30', title: '《速度与激情11》4K超清版本现已加入片库', tag: '4K专区' },
  { date: '07-29', title: '每日精选：五部豆瓣9分以上经典影片限时推荐', tag: '高分推荐' },
  { date: '07-28', title: '国漫专题更新：《长安三万里2》等多部佳作上线', tag: '专题更新' },
  { date: '07-27', title: '系统升级完成，观影加载速度提升30%', tag: '平台动态' },
  { date: '07-26', title: '奥斯卡获奖影片专区新增23部经典佳作', tag: '片库扩容' },
  { date: '07-25', title: '移动端观影体验优化，适配更多设备型号', tag: '体验优化' },
];

const MEDIA_ITEMS = [
  {
    title: '流浪地球3 · 官方预告解析',
    desc: '深度解析第三部世界观设定与视觉突破，探索人类命运的新篇章。',
    duration: '03:25',
    views: '128万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20space%20station%20interior%20with%20Earth%20visible%20through%20large%20window%2C%20dramatic%20blue%20and%20warm%20orange%20lighting%20contrast%2C%20cinematic%20atmosphere%2C%20high%20tech%20aesthetic%2C%20no%20text%20no%20people&width=720&height=420&seq=media-wandering-01&orientation=landscape',
  },
  {
    title: '封神第二部 · 幕后特辑',
    desc: '独家揭秘殷商大战幕后制作，从概念设计到最终成片的震撼历程。',
    duration: '05:18',
    views: '96万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20battlefield%20with%20epic%20scale%2C%20dramatic%20stormy%20sky%2C%20traditional%20armor%20and%20weapons%20aesthetic%2C%20warm%20golden%20and%20crimson%20tones%2C%20cinematic%20lighting%2C%20no%20text%20no%20people&width=720&height=420&seq=media-fengshen-02&orientation=landscape',
  },
  {
    title: '国漫十年 · 回顾与展望',
    desc: '从大圣归来到哪吒，回顾国产动画电影十年崛起之路与未来趋势。',
    duration: '08:42',
    views: '215万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20Chinese%20animation%20style%20landscape%20with%20floating%20mountains%20and%20magical%20elements%2C%20vibrant%20warm%20colors%2C%20ink%20wash%20and%20digital%20art%20fusion%2C%20dreamlike%20cinematic%20atmosphere%2C%20no%20text%20no%20characters&width=720&height=420&seq=media-anime-03&orientation=landscape',
  },
];

const TOPICS = [
  { label: '暑期档', hot: '爆' },
  { label: '科幻大片', hot: '热' },
  { label: '国漫崛起', hot: '新' },
  { label: '高分经典', hot: '' },
  { label: '动作冒险', hot: '' },
  { label: '悬疑烧脑', hot: '' },
  { label: '喜剧合家欢', hot: '热' },
  { label: '4K超清', hot: '荐' },
  { label: '院线新片', hot: '新' },
  { label: '独立电影', hot: '' },
  { label: '纪录片精选', hot: '' },
];

export function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-16 px-4 md:px-8 bg-background-100">
      <div className="max-w-[1100px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          影视分类索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mt-2 mb-10">
          按类型快速找到你想看的电影
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {INDEX_ITEMS.map((item, i) => (
            <a
              key={i}
              href="#hero"
              onClick={(e) => e.preventDefault()}
              className="flex items-center gap-3 bg-background-50 rounded-lg p-4 border border-background-200 hover:border-primary-200 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className={item.icon + ' text-lg text-primary-600'}></i>
              </div>
              <div className="min-w-0">
                <div className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{item.label}</div>
                <div className="text-xs text-foreground-400">{item.count}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-16 px-4 md:px-8 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          更新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mt-2 mb-10">
          最新影片上线与平台资讯
        </p>
        <div className="relative pl-8">
          <div className="absolute left-[11px] top-2 bottom-2 w-0.5 bg-background-200"></div>
          <div className="space-y-5">
            {UPDATES.map((item, i) => (
              <div key={i} className="relative">
                <div className="absolute -left-[27px] top-1 w-3.5 h-3.5 rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="flex items-start gap-3 flex-wrap">
                  <span className="text-xs font-mono text-foreground-400 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap">{item.date}</span>
                  <span className="text-sm text-foreground-700 leading-relaxed flex-1 min-w-0">{item.title}</span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-16 px-4 md:px-8 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          精彩看点
        </h2>
        <p className="text-sm text-foreground-500 text-center mt-2 mb-10">
          热门影片预告与幕后花絮
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {MEDIA_ITEMS.map((item, i) => (
            <div key={i} className="group bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-200 transition-all cursor-pointer">
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-white transition-all">
                    <i className="ri-play-fill text-xl text-primary-600 group-hover:text-white ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 text-xs bg-black/60 text-white px-2 py-0.5 rounded">{item.duration}</div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">{item.desc}</p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-16 px-4 md:px-8 bg-background-50">
      <div className="max-w-[1000px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mt-2 mb-10">
          大家都在关注什么
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((item, i) => (
            <a
              key={i}
              href="#hero"
              onClick={(e) => e.preventDefault()}
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full border border-background-200 bg-background-100 hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-700">{item.label}</span>
              {item.hot && (
                <span className={'text-xs px-1.5 py-0.5 rounded-full font-bold whitespace-nowrap ' + (
                  item.hot === '爆' ? 'bg-primary-500 text-white' :
                  item.hot === '热' ? 'bg-accent-500 text-white' :
                  item.hot === '新' ? 'bg-secondary-500 text-white' :
                  'bg-accent-100 text-accent-700'
                )}>
                  {item.hot}
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}